const ArchivedBody = () => {
  return (
    <p>
      The Archived Validated Products List is a repository of products validated
      under CCEVS which have expired Assurance Maintenance Dates as detailed in
      Publication #6. Per CNSSP #11, products listed below are no longer
      procurable for use on National Security Systems, but may continue to be
      used if already employed within your organization’s IT infrastructure. For
      further information, see{" "}
      <a
        target="_blank"
        href="https://www.niap-ccevs.org/Documents_and_Guidance/ccevs/The%20Relationship%20of%20NIAP%20Archived%20Products%20to%20CNSSP-11.pdf"
        rel="noreferrer"
      >
        Relationship of NIAP Archived Products to CNSSP-11
      </a>
      .
    </p>
  );
};
export default ArchivedBody;
